import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { map, switchMap, tap } from "rxjs/operators";
import { ICourse, ISchool, SchoolsService } from "src/app/services";

@Component({
  selector: "app-schools",
  templateUrl: "./schools.component.html",
  styleUrls: ["./schools.component.scss"],
})
export class SchoolsComponent implements OnInit, AfterViewInit {
  @ViewChild("schoolsTab", null)
  public defaultTab: ElementRef;

  private schoolName$: BehaviorSubject<string> = new BehaviorSubject(null);
  public schools$: Observable<ISchool[]>;
  public selectedSchool$: Observable<ISchool>;
  public activeTab: ElementRef;
  public selectedCourse: ICourse;

  public isPanelOpened: boolean = false;
  chartOrientation = "horizontal";

  constructor(
    private readonly schoolsService: SchoolsService,
    private readonly route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe(
      (params: ParamMap) => {
        this.schoolName$.next(params.get("name"));
      },
    );
    this.schools$ = this.schoolsService.getAll();

    //
    this.selectedSchool$ = this.schools$.pipe(
      map((schools: ISchool[]) => {
        return schools ? schools[0] : null;
      }),
      tap((school: ISchool) => {
        if (!school.defaultCourseId || !school.courses || school.courses.length === 0) {
          return;
        }
        this.selectedCourse = school.courses.find((course: ICourse) => course.id === school.defaultCourseId);
        if (!this.selectedCourse) {
          console.warn(`Cannot find Course by defaultCourseId: ${school.defaultCourseId}`);
          return;
        }
        this.togglePanel(true);
      })
    );
    // TODO: Switch back later
    // this.selectedSchool$ = this.schoolName$.pipe(
    //   switchMap((name: string) => this.schools$.pipe(
    //     map((schools: ISchool[]) => {
    //       const found = schools.find((s) => s.name === name);
    //       return found;
    //     })
    //   )),
    // );
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setTab(this.defaultTab.nativeElement);
    }, 0);

  }

  public setTab(tab: ElementRef) {
    this.activeTab = tab || this.defaultTab.nativeElement;
  }

  public setSelectedCourse(course: ICourse) {
    this.selectedCourse = course;

    this.togglePanel(true);
  }

  public seedClick() {
    this.schoolsService.createTestSchool()
      .catch((e) => console.error(e));
  }

  public togglePanel(forceState?: boolean) {
    if (forceState) {
      this.isPanelOpened = forceState;
    } else {
      this.isPanelOpened = !this.isPanelOpened;
    }
  }

  toggleOrientation() {
    this.chartOrientation = this.chartOrientation === "horizontal" ? "vertical" : "horizontal";
  }
}
